import { Component, OnInit } from '@angular/core';
import { DatePipe } from "@angular/common";
import { Direction } from 'src/app/parametrage/core/model/direction';
import { DirectionService } from 'src/app/parametrage/core/service/direction.service';
import { ReportingDirectionService } from '../core/service/reporting-direction.service';

@Component({
  selector: 'app-extraction-direction',
  templateUrl: './extraction-direction.component.html',
  styleUrls: ['./extraction-direction.component.scss']
})
export class ExtractionDirectionComponent implements OnInit {
  
  debut: any = null;
  fin: any = null;
  direction: String;

  directions: Direction[];

  constructor(
    private datePipe: DatePipe,
    private _directionService: DirectionService,
    private _reportingService: ReportingDirectionService
  ) {}

  ngOnInit() {
    this.getUserProfiles();
  }

  getUserProfiles() {
    this._directionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  exportDossiersEncoursByDirection() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersEncoursByDirection(deb, fn, this.direction)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "dossiers-en-cours-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  
  exportDossiersValideByDirection() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersValideByDirection(deb, fn, this.direction)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "dossiers-valide-" + this.debut + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }



}
